// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Suggestion Chips Container */
.suggestion-chips {
  margin-top: 12px;
  padding: 12px;
  background: #f7f7f9;
  border-radius: 12px;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.suggestion-label {
  font-size: 12px;
  color: #666;
  margin: 0 0 8px;
  font-weight: 500;
  font-family: 'Roboto', sans-serif;
}

/* Chips Container */
.chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

/* Individual Chip */
.chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: #fff;
  border: 1.5px solid #d5a32a;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 13px;
  font-weight: 500;
  color: #1b2c5a;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  font-family: 'Roboto', sans-serif;
  position: relative;
  overflow: hidden;
  animation: slideIn 0.3s ease-out backwards;
}

/* Staggered entrance animation */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.chip:nth-child(1) { animation-delay: 0.05s; }
.chip:nth-child(2) { animation-delay: 0.1s; }
.chip:nth-child(3) { animation-delay: 0.15s; }
.chip:nth-child(4) { animation-delay: 0.2s; }

/* Hover State */
.chip:hover:not(:disabled) {
  background: #d5a32a;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(213, 163, 42, 0.3);
}

/* Active/Clicked State */
.chip:active:not(:disabled) {
  transform: translateY(0) scale(0.98);
}

.chip.clicked {
  background: #d5a32a;
  color: #fff;
  transform: scale(0.95);
}

/* Disabled State */
.chip.disabled,
.chip:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

/* Focus Visible for Keyboard Users */
.chip:focus-visible {
  outline: 3px solid #1b2c5a;
  outline-offset: 2px;
}

/* Chip Icon */
.chip-icon {
  font-size: 16px;
  line-height: 1;
  display: inline-flex;
  align-items: center;
}

/* Chip Text */
.chip-text {
  white-space: nowrap;
  line-height: 1;
}

/* Chip Loader (spinning emoji) */
.chip-loader {
  animation: spin 1s linear infinite;
  display: inline-block;
  margin-right: 4px;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

/* Ripple Effect on Click */
.chip::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  transform: translate(-50%, -50%);
  transition: width 0.4s, height 0.4s;
  pointer-events: none;
}

.chip:active:not(:disabled)::after {
  width: 200px;
  height: 200px;
}

/* High Contrast Mode Support */
@media (prefers-contrast: high) {
  .chip {
    border-width: 2px;
  }
}

/* Reduced Motion Support */
@media (prefers-reduced-motion: reduce) {
  .chip,
  .suggestion-chips {
    animation: none;
    transition: none;
  }
  
  .chip-loader {
    animation: none;
  }
}

/* Mobile Optimizations */
@media (max-width: 768px) {
  .suggestion-chips {
    padding: 10px;
  }

  .chips-container {
    gap: 6px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none; /* Firefox */
    padding-bottom: 2px; /* Prevent shadow cutoff */
  }

  .chips-container::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }

  .chip {
    padding: 7px 12px;
    font-size: 12px;
    scroll-snap-align: start;
    flex-shrink: 0; /* Prevent squishing on small screens */
  }

  .chip-icon {
    font-size: 14px;
  }
}

/* Small Mobile */
@media (max-width: 480px) {
  .chip {
    padding: 6px 10px;
    font-size: 11px;
  }
  
  .chip-icon {
    font-size: 13px;
  }
  
  .suggestion-label {
    font-size: 11px;
  }
}












`, "",{"version":3,"sources":["webpack://./src/components/SuggestionChips.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,oBAAoB;AACpB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB,sBAAsB,EAAE;AAC7C,qBAAqB,qBAAqB,EAAE;AAC5C,qBAAqB,sBAAsB,EAAE;AAC7C,qBAAqB,qBAAqB,EAAE;;AAE5C,gBAAgB;AAChB;EACE,mBAAmB;EACnB,WAAW;EACX,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;;EAEE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,qCAAqC;AACrC;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,kCAAkC;EAClC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,KAAK,yBAAyB,EAAE;AAClC;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,gBAAgB;IAChB,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB,EAAE,YAAY;IACnC,mBAAmB,EAAE,0BAA0B;EACjD;;EAEA;IACE,aAAa,EAAE,kBAAkB;EACnC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,cAAc,EAAE,uCAAuC;EACzD;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Suggestion Chips Container */\r\n.suggestion-chips {\r\n  margin-top: 12px;\r\n  padding: 12px;\r\n  background: #f7f7f9;\r\n  border-radius: 12px;\r\n  animation: fadeIn 0.3s ease-in;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(-10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.suggestion-label {\r\n  font-size: 12px;\r\n  color: #666;\r\n  margin: 0 0 8px;\r\n  font-weight: 500;\r\n  font-family: 'Roboto', sans-serif;\r\n}\r\n\r\n/* Chips Container */\r\n.chips-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 8px;\r\n}\r\n\r\n/* Individual Chip */\r\n.chip {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 8px 14px;\r\n  background: #fff;\r\n  border: 1.5px solid #d5a32a;\r\n  border-radius: 20px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #1b2c5a;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\r\n  font-family: 'Roboto', sans-serif;\r\n  position: relative;\r\n  overflow: hidden;\r\n  animation: slideIn 0.3s ease-out backwards;\r\n}\r\n\r\n/* Staggered entrance animation */\r\n@keyframes slideIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0);\r\n  }\r\n}\r\n\r\n.chip:nth-child(1) { animation-delay: 0.05s; }\r\n.chip:nth-child(2) { animation-delay: 0.1s; }\r\n.chip:nth-child(3) { animation-delay: 0.15s; }\r\n.chip:nth-child(4) { animation-delay: 0.2s; }\r\n\r\n/* Hover State */\r\n.chip:hover:not(:disabled) {\r\n  background: #d5a32a;\r\n  color: #fff;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 8px rgba(213, 163, 42, 0.3);\r\n}\r\n\r\n/* Active/Clicked State */\r\n.chip:active:not(:disabled) {\r\n  transform: translateY(0) scale(0.98);\r\n}\r\n\r\n.chip.clicked {\r\n  background: #d5a32a;\r\n  color: #fff;\r\n  transform: scale(0.95);\r\n}\r\n\r\n/* Disabled State */\r\n.chip.disabled,\r\n.chip:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  pointer-events: none;\r\n}\r\n\r\n/* Focus Visible for Keyboard Users */\r\n.chip:focus-visible {\r\n  outline: 3px solid #1b2c5a;\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* Chip Icon */\r\n.chip-icon {\r\n  font-size: 16px;\r\n  line-height: 1;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n/* Chip Text */\r\n.chip-text {\r\n  white-space: nowrap;\r\n  line-height: 1;\r\n}\r\n\r\n/* Chip Loader (spinning emoji) */\r\n.chip-loader {\r\n  animation: spin 1s linear infinite;\r\n  display: inline-block;\r\n  margin-right: 4px;\r\n}\r\n\r\n@keyframes spin {\r\n  from { transform: rotate(0deg); }\r\n  to { transform: rotate(360deg); }\r\n}\r\n\r\n/* Ripple Effect on Click */\r\n.chip::after {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  border-radius: 50%;\r\n  background: rgba(255, 255, 255, 0.5);\r\n  transform: translate(-50%, -50%);\r\n  transition: width 0.4s, height 0.4s;\r\n  pointer-events: none;\r\n}\r\n\r\n.chip:active:not(:disabled)::after {\r\n  width: 200px;\r\n  height: 200px;\r\n}\r\n\r\n/* High Contrast Mode Support */\r\n@media (prefers-contrast: high) {\r\n  .chip {\r\n    border-width: 2px;\r\n  }\r\n}\r\n\r\n/* Reduced Motion Support */\r\n@media (prefers-reduced-motion: reduce) {\r\n  .chip,\r\n  .suggestion-chips {\r\n    animation: none;\r\n    transition: none;\r\n  }\r\n  \r\n  .chip-loader {\r\n    animation: none;\r\n  }\r\n}\r\n\r\n/* Mobile Optimizations */\r\n@media (max-width: 768px) {\r\n  .suggestion-chips {\r\n    padding: 10px;\r\n  }\r\n\r\n  .chips-container {\r\n    gap: 6px;\r\n    overflow-x: auto;\r\n    scroll-snap-type: x mandatory;\r\n    -webkit-overflow-scrolling: touch;\r\n    scrollbar-width: none; /* Firefox */\r\n    padding-bottom: 2px; /* Prevent shadow cutoff */\r\n  }\r\n\r\n  .chips-container::-webkit-scrollbar {\r\n    display: none; /* Chrome/Safari */\r\n  }\r\n\r\n  .chip {\r\n    padding: 7px 12px;\r\n    font-size: 12px;\r\n    scroll-snap-align: start;\r\n    flex-shrink: 0; /* Prevent squishing on small screens */\r\n  }\r\n\r\n  .chip-icon {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n/* Small Mobile */\r\n@media (max-width: 480px) {\r\n  .chip {\r\n    padding: 6px 10px;\r\n    font-size: 11px;\r\n  }\r\n  \r\n  .chip-icon {\r\n    font-size: 13px;\r\n  }\r\n  \r\n  .suggestion-label {\r\n    font-size: 11px;\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
